export const fonts = {
  empty: '0.0000rem',
  sizeText: '0.8750rem',
  sizeMedium: '1.0000rem',
  sizeTitle: '1.1250rem',
  sizeCardTitle: '1.2500rem',
  sizeCustom10: '0.6250rem',
  sizeCustom11: '0.6875rem',
  sizeCustom12: '0.7500rem',
  sizeCustom14: '0.8750rem',
  sizeCustom15: '0.9375rem',
  sizeCustom16: '1.0000rem',
  sizeCustom17: '1.0625rem',
  sizeCustom18: '1.1250rem',
  sizeCustom19: '1.1875rem',
  sizeCustom32: '2.0000rem',
  sizeCustom22: '1.3750rem',
  sizeCustom24: '1.5000rem',
  sizeCustom28: '1.7500rem',
  sizeCustom74: '4.6250rem',
  sizeCustom42: '2.6250rem',
  sizeCustom100: '6.2500rem',
  sizeCustom150: '9.3750rem',
  weight50: 50,
  weight300: 300,
  weight400: 400,
  regular: 500,
  weight500: 500,
  weight540: 540,
  weight550: 550,
  weight600: 600,
  bold: 700,
  weight700: 700,
  weight800: 800,
  weightNormal: 'normal',
  italic: 'italic',
  customFontResponsive: '0.8125rem',
  customFontNodeResponsive: '0.75rem',
  letterSpacing01Px: '0.1px',
  letterSpacing046: '0.46px',
  letterSpacing1p1: '1.1px',
  letterSpacing05: '0.5px',
  letterSpacing04: '0.4px',
  letterSpacing01: '0.1px',
  letterSpacing015: '0.15px',
  letterSpacingNeg1p5: '-1.5px',
  letterSpacing016: '0.16px',
  letterSpacing017: '0.17px',
  letterSpacing025: '0.25px',
  letterSpacing008em: '0.08em',
  lineHeight24px: '24px',
  lineHeight115: 1.15,
  lineHeight125: 1.25,
  lineHeight135: 1.35,
  lineHeight133: 1.33,
  lineHeight143: 1.43,
  lineHeight150: 1.5,
  lineHeight157: 1.57,
  lineHeight240: '15rem',
  lineHeight220: '13.75rem',
  lineHeight160: '10rem',
  lineHeight126: '7.875rem',
  lineHeight85: '5.3125rem',
  lineHeight80: '5rem',
  lineHeight70: '4.375rem',
  lineHeight64: '4rem',
  lineHeight60: '3.75rem',
  lineHeight58: '3.625rem',
  lineHeight56: '3.5rem',
  lineHeight52: '3.25rem',
  lineHeight51p25: '3.203125rem',
  lineHeight51: '3.1875rem',
  lineHeight47: '2.9375rem',
  lineHeight46: '2.875rem',
  lineHeight45: '2.8125rem',
  lineHeight42: '2.625rem',
  lineHeight40: '2.5rem',
  lineHeight38: '2.375rem',
  lineHeight37: '2.3125rem',
  lineHeight36: '2.25rem',
  lineHeight35: '2.1875rem',
  lineHeight34: '2.125rem',
  lineHeight32: '2rem',
  lineHeight30: '1.875rem',
  lineHeight29: '1.8125rem',
  lineHeight28p7: '1.79375rem',
  lineHeight28: '1.75rem',
  lineHeight26p4: '1.65rem',
  lineHeight26: '1.625rem',
  lineHeight25: '1.5625rem',
  lineHeight24: '1.5rem',
  lineHeight22: '1.375rem',
  lineHeight21: '1.3125rem',
  lineHeight20: '1.25rem',
  lineHeight19: '1.1875rem',
  lineHeight19p2: '1.2rem',
  lineHeight18: '1.125rem',
  lineHeight17: '1.0625rem',
  lineHeight16: '1rem',
  lineHeight15: '0.9375rem',
  lineHeight117Percent: '117%',
  lineHeight166Percent: '166%',
  lineHeight160Percent: '160%',
  lineHeight157Percent: '157%',
  lineHeight150Percent: '150%',
  lineHeight14: '0.875rem',
  lineHeight12: '0.75rem',
  lineHeight10: '0.625rem',
  lineHeight8: '0.5rem',
  lineHeight0p8: '0.0500rem',
  lineHeight1p5: '0.0938rem',
  lineHeight1p1: '0.0688rem',
  lineHeightCustom1: '0.0625rem',
  fontSize200: '12.5rem',
  fontSize150: '9.3rem',
  fontSize105: '6.5rem',
  fontSize85: '5.3rem',
  fontSize70: '4.3rem',
  fontSize64: '4rem',
  fontSize60: '3.7rem',
  fontSize56: '3.5rem',
  fontSize55: '3.4rem',
  fontSize54: '3.3rem',
  fontSize52: '3.2rem',
  fontSize50: '3.1rem',
  fontSize48: '3rem',
  fontSize46: '2.8rem',
  fontSize45: '2.8rem',
  fontSize42: '2.6rem',
  fontSize40: '2.5rem',
  fontSize38: '2.3rem',
  fontSize36: '2.2rem',
  fontSize35: '2.1rem',
  fontSize34: '2.125rem',
  fontSize32: '2rem',
  fontSize30: '1.8rem',
  fontSize28: '1.7rem',
  fontSize26: '1.6rem',
  fontSize25: '1.5rem',
  fontSize24: '1.4rem',
  fontSize22: '1.375rem',
  fontSize20: '1.25rem',
  fontSize19: '1.1875rem',
  fontSize18: '1.1rem',
  fontSize17: '1rem',
  fontSize16: '1rem',
  fontSize15: '0.9rem',
  fontSize14px: '14px',
  fontSize14: ' 0.875rem',
  fontSize13: '0.8rem',
  fontSize12p5: '0.78125rem',
  fontSize12: '0.75rem',
  fontSize10: '0.6rem',
  fontSize11: '0.6rem',
  fontSize8: '0.5rem',
  fontSizeEmpty: '0.0000rem',
  styleNormal: 'normal',
  fontFamily: '"Red Hat Display", sans-serif',
  fontFamilyRoboto: 'Roboto',
  fontPercentage: '7.5000rem !important',
  fontPercentageMobile: '4.2500rem !important',
  fontPercentageModal: '4.3750rem !important',
  letterSpacing20: '1.2500rem',
  letterSpacing0: '0rem',
  letterSpacing1: '0.0688rem',
  letterSpacing2: '0.1250rem',
  fontPercentageSymbol: '2.6250rem',
  fontSize07em: '0.7em',
  fontSize08em: '0.8em',
  fontSize09em: '0.9em',
  fontSize1em: '1em',
  fontSize12em: '1.2em',
  fontSize1p6em: '1.6em',
  fontSize225em: '2.25em',
  fontSize27em: '2.7em',
  fontSize3em: '3em',
  fontSize37em: '3.7em',
  fontSize0p7rem: '0.7rem',
  fontSize0875rem: '0.875rem',
  fontSize0p9rem: '0.9rem',
  fontSize1rem: '1rem',
  fontSize1125rem: '1.125rem',
  fontSize125rem: '1.25rem',
  fontSize1375rem: '1.375rem',
  fontSize15rem: '1.5rem',
  fontSize17rem: '1.7rem',
  fontSize175rem: '1.75rem',
  fontSize1p8rem: '1.8rem',
  fontSize1p875rem: '1.875rem',
  fontSize19rem: '1.9rem',
  fontSize3rem: '3rem',
  iconFontSize: '2.3125rem',
  fontSize101: '6.3125rem',
  threeHalfVmin: '3.5vmin',
};
